import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Sidebar.css';
import { FiAward, FiBell, FiClipboard, FiCreditCard, FiFileText, FiGlobe, FiGrid, FiHelpCircle, FiImage, FiLayers, FiLayout, FiLifeBuoy, FiSettings, FiShoppingBag, FiStar, FiTarget, FiTool, FiTrendingUp, FiUserCheck, FiUsers, FiMapPin, FiShare2, FiBookOpen, FiSearch, FiCheckCircle } from 'react-icons/fi';

const Sidebar = ({ isOpen, onClose }) => {
  const location = useLocation();
  const [websiteManagementOpen, setWebsiteManagementOpen] = useState(false);
  const [stateManagementOpen, setStateManagementOpen] = useState(false);
  

  const menuItems = [
    { path: '/dashboard', label: 'Dashboard', icon: <FiGrid /> },
    // { path: '/billing', label: 'Billing', icon: <FiFileText />  },
     { path: '/invoices', label: 'Invoices', icon: <FiFileText /> },
    { path: '/service', label: 'Service', icon: <FiLayers />  },
    { path: '/user-management', label: 'User Management', icon: <FiUsers /> },
    { path: '/claimed-vendors', label: 'Claimed Profiles', icon: <FiCheckCircle /> },
    { path: '/plan-management', label: 'Plan Management', icon: <FiClipboard /> },
    { path: '/order-history', label: 'Enquiry Management', icon: <FiShoppingBag /> },
    { path: '/meta-ads', label: 'Meta Ads Requests', icon: '📢' },
    { path: '/post-management', label: 'Post Management', icon: <FiShare2 /> },
    { path: '/agent-management', label: 'Agent Management', icon: <FiUserCheck /> },
    { path: '/deleted-users', label: 'Deleted Users', icon: <FiUsers /> },
    // { path: '/target', label: 'Target', icon: <FiTarget /> },
    { path: '/target-management', label: 'Target Management', icon: '🎯' },
    { path: '/handpicked-vendors', label: 'Handpicked Vendors', icon:<FiAward />  },
    { path: '/featured-categories', label: 'Featured Categories', icon: <FiStar /> },
    { path: '/gallery-images', label: 'Gallery Images', icon: <FiImage /> },
    { path: '/portfolio-approval', label: 'Portfolio Approval', icon: <FiImage /> },
    { path: '/coin-price', label: 'Coin Price', icon: <FiCreditCard /> },
    { path: '/coin-percent-use', label: 'Coin Percent Use', icon: <FiTrendingUp /> },
    { path: '/audit-logs', label: 'Audit Logs', icon: <FiClipboard /> },
    { path: '/notifications', label: 'Push Notifications', icon: <FiBell /> },
    { path: '/settings', label: 'Settings', icon: <FiSettings /> }
  ];

  const websiteManagementItems = [
    { path: '/faq', label: 'FAQ', icon: <FiHelpCircle /> },
    { path: '/help-support', label: 'Help and Support', icon: <FiLifeBuoy /> },
    { path: '/banners', label: 'Banners', icon: <FiLayout /> },
    { path: '/website-content', label: 'Website Content', icon: <FiLayout /> },
    { path: '/blog-management', label: 'Blog Management', icon: <FiBookOpen /> },
    { path: '/seo-content', label: 'SEO Content', icon: <FiSearch /> },
    { path: '/thank-you-page', label: 'Thank You Pages', icon: <FiCheckCircle /> },
  ];

    const stateManagementItems = [
    { path: '/states', label: 'States', icon: <FiMapPin /> },
    { path: '/commissionaries', label: 'Commissionaries', icon: <FiGrid /> },
    { path: '/districts', label: 'Districts', icon: <FiLayers /> }
  ];

  const handleLinkClick = () => {
    if (window.innerWidth <= 768) {
      onClose();
    }
  }

  return (
    <>
      {isOpen && <div className="sidebar-overlay show" onClick={onClose}></div>}
      <div className={`sidebar ${isOpen ? 'open' : ''}`}>
        <div className="sidebar-header">
          <div className="logo">
            <img src="/bandhanguru_logo.svg" alt="Bandhan Guru" className="logo-img" />
            <span className="logo-text">BANDHAN GURU</span>
            <span className="logo-tagline">TRADITION TRUST TOGETHER</span>
          </div>
        </div>
        
        <nav className="sidebar-nav">

          {console.log(location.pathname)}
          {menuItems.slice(0, -1).map((item) => (
            
            <Link
              key={item.path}
              to={item.path}
              className={`nav-item ${location.pathname.startsWith(item.path) ? 'active' : ''}`}
              
              onClick={handleLinkClick}
            >
              <span className="nav-icon">{item.icon}</span>
              <span className="nav-label">{item.label}</span>
            </Link>
          ))}

            <div className="nav-item dropdown-toggle" onClick={() => setStateManagementOpen(!stateManagementOpen)}>
            <span className="nav-icon"><FiMapPin /></span>
            <span className="nav-label">State Management</span>
            <span className={`dropdown-arrow ${stateManagementOpen ? 'rotated' : ''}`}>▼</span>
          </div>
          
          {stateManagementOpen && stateManagementItems.map((item) => (
            <Link
              key={item.path}
              to={item.path}
              className={`nav-item dropdown-item-link ${location.pathname.startsWith(item.path) ? 'active' : ''}`}
              onClick={handleLinkClick}
            >
              <span className="nav-icon">{item.icon}</span>
              <span className="nav-label">{item.label}</span>
            </Link>
          ))}
          
          <div className="nav-item dropdown-toggle" onClick={() => setWebsiteManagementOpen(!websiteManagementOpen)}>
            <span className="nav-icon"><FiGlobe /></span>
            <span className="nav-label">Website Management</span>
            <span className={`dropdown-arrow ${websiteManagementOpen ? 'rotated' : ''}`}>▼</span>
          </div>
          
          {websiteManagementOpen && websiteManagementItems.map((item) => (
            <Link
              key={item.path}
              to={item.path}
              className={`nav-item dropdown-item-link ${location.pathname === item.path ? 'active' : ''}`}
              onClick={handleLinkClick}
            >
              <span className="nav-icon">{item.icon}</span>
              <span className="nav-label">{item.label}</span>
            </Link>
          ))}
          
          {menuItems.slice(-1).map((item) => (
            <Link
              key={item.path}
              to={item.path}
              className={`nav-item ${location.pathname === item.path ? 'active' : ''}`}
              onClick={handleLinkClick}
            >
              <span className="nav-icon">{item.icon}</span>
              <span className="nav-label">{item.label}</span>
            </Link>
          ))}
        </nav>
      </div>
    </>
  );
};

export default Sidebar;